import React  from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import TrainingClassParticipantTable from "./components/TrainingClassParticipantTable";


const TrainingClassParticipants = () => {
	
	const { classeId } = useParams();

	return (
			<div>		    		
				<TrainingClassParticipantTable classeId={classeId} />
			</div>
    );
};

const mapStateToProps = (state) => ({
  	  
});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingClassParticipants);